import api from "../../../api";
import React, { useEffect, useState } from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import ServiceScreen from "..";

import { useQuery } from "react-query";
import { IFindUserInformation } from "../../../types/common.interface";
import {
  IUpdateService,
  TModalService,
} from "../../../types/service.interface";
import {
  ICreateStudent,
  IUpdateStudent,
} from "../../../types/student.interface";
import { Approve_Service_AdminiStrator } from "../../../types/common.type";
import errorHandler from "../../../utils/errorHandler";

const AdministratorServiceContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModalService>("NONE");
  const [selectedUser, setSelectedUser] = React.useState<any>();
  const [selectedService, setSelectedService] = React.useState<any>();
  const [requestStudents, setRequestStudents] = React.useState<any>();
  const [requestService, setRequestService] =
    React.useState<IFindUserInformation>({
      filters: { isUnknownDriver: false },
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      page: 1,
    });
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------

  const resultStudentId = useQuery(
    [requestStudents],
    () =>
      api.post.common.findStudent({
        search: {
          base: requestStudents?.search?.base?.split(".")[1],
          value: requestStudents?.search?.value,
        },
      }),
    { enabled: !!requestStudents?.search?.base }
  );

  // ? Panel-wide academic year (سال تحصیلی). It has to be part of the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  let resultService = useQuery(
    [
      values.useQueryKeys.getAllService,
      requestService?.page,
      resultStudentId,
      requestService?.search?.value,
      requestService?.filters,
      selectedYear?._id,
    ],
    () =>
      api.post.common.findService({
        filters: {
          ...requestService?.filters,
          student: resultStudentId?.data?.result?.docs
        },
        limit: requestService?.limit,
        page: requestService?.page,
        academicYear: selectedYear?._id,
      })
  );

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                                Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------
  async function createFunction(formData: ICreateStudent) {
    setIsLoading(true);
    const result = await api.post.common.createStudent(formData);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultService.refetch();
      setShowModal("NONE");
      setIsLoading(false);
      return true;
    }
    setIsLoading(false);
    return false;
  }
  async function updateFunctionStudent(formData: IUpdateStudent) {
    setIsLoading(true);
    const result = await api.put.common.updateStudent(formData);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultService.refetch();
      setShowModal("NONE");
    }
    errorHandler(result?.CODE);
    setIsLoading(false);
    return false;
  }
  async function updateFunctionService(formData: IUpdateService) {
    setIsLoading(true);
    const result = await api.put.common.updateService(formData);
    if (result) {
      utils.successHandler(Number(result?.CODE));
      resultService.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }
  async function deleteFunction(userId: string) {
    console.log(userId);
    // setIsLoading(true);
    // const result = await api.dele.common.deleteSchool(userId);
    // if (result) {
    //   utils.successHandler(Number(result.CODE));
    //   resultService.refetch();
    //   setShowModal("NONE");
    // }
    // setIsLoading(false);
    return false;
  }
  async function approveFunction(props: {
    _id: string;
    isApprove: boolean;
    approveType: Approve_Service_AdminiStrator;
  }) {
    setIsLoading(true);
    const result = await api.put.administrator.approveService(props);
    if (result) {
      utils.successHandler(Number(result.CODE));
      resultService.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  async function uploadImage(imageFile: File) {
    return await api.post.common.uploadImage(imageFile);
  }

  async function payFunction(props: any) {
    console.log(props);
    setIsLoading(true);
    const result = await api.post.company.payOflineService({
      ...props,
      serviceId: selectedService._id,
    });
    if (result) {
      utils.successHandler(Number(2010));
      resultService.refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  async function approveDriver(): Promise<void> {
    setIsLoading(true);
    await api.patch.administrator.serviceApproveDriver(selectedService._id);
    await resultService.refetch();
    setShowModal("NONE");
    setIsLoading(false);
  }

  async function rejectDriver(): Promise<void> {
    setIsLoading(true);
    await api.patch.administrator.serviceRemoveDriver(selectedService._id);
    await resultService.refetch();
    setShowModal("NONE");
    setIsLoading(false);
  }

  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.ServiceScreen.Provider
      value={{
        showModal,
        isLoading,
        payFunction,
        uploadImage,
        setShowModal,
        selectedUser,
        rejectDriver,
        approveDriver,
        deleteFunction,
        requestService,
        createFunction,
        approveFunction,
        setSelectedUser,
        requestStudents,
        selectedService,
        setRequestService,
        setSelectedService,
        setRequestStudents,
        updateFunctionService,
        updateFunctionStudent,
      }}
    >
      <ServiceScreen resultService={resultService} role="ADMIN" />
    </Context.ServiceScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default AdministratorServiceContainer;
